export const redGreenTheme = {
  palette: {
    mode: "dark",
    // type: 'light',
    primaryBG: {
      live: "",
      700: "#000", // black color accordian color
      650: "#180920",
      625: "#17091f",
      600: "#101211", //background main
      550: "#1d0b27",
      500: "#101211", //black color on header
      450: "#0A2024", //darkshade grey //top most header buttons
      400: "#0A2024", //dark purple on header
      380: "#0A2024", //calender BG
      350: "#05363a", //sidebar acoount subsections bg color
      300: "#12494E", //light purple outcome container color
      250: "#4c0f77", //chat support bg
      200: "#4e0077"
    },
    secondaryBG: {
      main: "#FF014D"
    },
    primaryText: {
      800: "#8C8989",
      400: "#bbb7b7",
      300: "#645151",
      250: "#a6a4a4",
      200: "#949494", // grey
      100: "#FFFFFF" // white
    },
    secondaryText: {
      700: "#ffff", // black color accordian color
      650: "#180920",
      625: "#17091f",
      600: "#101211", //black casino header
      550: "#1d0b27",
      500: "#101211", //black color on header
      450: "#0A2024", //darkshade grey //top most header buttons
      400: "#0A2024", //dark purple on header
      380: "#0A2024",
      350: "#330244", //sidebar acoount subsections bg color
      300: "#12494E", //light purple outcome container color
      250: "#4c0f77", //chat support bg
      200: "#4e0077"
    },

    supportChatText: {
      border: "#545050",
      main: "#434352"
    },
    scroll: {
      350: "#434352", //scroller color
      track: "#2F7379"
    },
    myBetBtnBG: {
      700: "#ABABAB",
      600: "#949494", // grey
      500: "#FF006B", //pink color on mybet page
      400: "#00FFFF", //light blue color on mybet page
      300: "#0F6", //green color on mybet,
      getCashoutBtn: "#2F7379"
    },
    myBetBtnText: "#000",
    resultHighlightOutcome: "#00FF66",
    topMatchLive: "linear-gradient(90deg, #2F064B 0%, #731C1C 100%)",
    betSlipGreadient:
      "linear-gradient(89.99deg, #2F7379 5.81%, #FF014D 94.84%)",
    primary2TextColor: {
      main: "#FF014D" // yellow
    },
    betHistory: {
      primaryBG: "#260133",
      secondaryBG: "#2e043d",
      secondarycolor: "#2e043d",
      optionBG: "#4e0077"
    },
    textFieldBorder: "#256a70",
    activeFavBG: {
      main: "#2F7379"
    },
    casinoSearch: {
      inputBG: "#12494E",
      categoryBG: "#0A2024",
      primaryBG: "#0A2024" // popup header
    },
    scoreHeader: {
      main: "#67627b"
    },
    nomatches: "#00767b",
    betGradient: {
      main: "linear-gradient(90deg, #12494E 0.21%, #2F7379 100.21%)",
      before: "linear-gradient(89.99deg, #2F7379 5.81%, #FF014D 94.84%)"
    },
    betSlipErrMsg: "#FF006B",
    appHeaderButtonBG: {
      active: "#FF014D",
      main: "#0A2024"
    },
    appHeaderText: {
      main: "#ffff",
      active: "#ffff"
    },
    sportbookSearchBtn: {
      bg: "#2F7379",
      text: "#fff",
      hoverBg: "#FF014D",
      hoverText: "#fff"
    },
    homeborderGradient: "linear-gradient(180deg, #5B0B23 0%, #FF014D 100%)"
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "*::-webkit-scrollbar": {
          width: "0.4em"
        },
        "*::-webkit-scrollbar-track": {
          "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)"
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: "#00767b",
          borderRadius: 10
        }
      }
    },
    MuiList: {},
    MuiTabs: {
      flexContainer: {
        justifyContent: "flex-start",
        alignItems: "center",
        display: "flex",
        "@media (max-width: 991px)": {
          justifyContent: "flex-start"
        }
      }
    },
    MuiContainer: {},
    MuiTableCell: {}
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& fieldset": {
            borderColor: "#256a70 !important"
          }
        }
      }
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: "#0A2024" // Use theme color for CircularProgress
        }
      }
    },

    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          // Styles for the root element of the MuiCalendarPicker
          "& .MuiPickersDay-root": {
            backgroundColor: "#12494E",
            color: "#fff"
          },
          "& .MuiPickersDay-root.Mui-selected": {
            backgroundColor: "#FF014D !important",
            color: "#000",
            fontWeight: 700
          },
          "& .MuiPickersDay-root:hover": {
            backgroundColor: "#FF014D",
            color: "#000"
          }
        }
      }
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: "#0A2024" // Custom background color
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#12494E"
          },
          "&.Mui-selected": {
            backgroundColor: "#12494E",
            "&:hover": {
              backgroundColor: "#FF014D"
            }
          },
          "&.MuiPaginationItem-previousNext": {
            background: "none",
            "&:hover": {
              backgroundColor: "none"
            }
          }
        }
      }
    }
  },
  typography: {
    fontFamily: "Poppins"
  }
};
